module.exports = __webpack_public_path__ + "images/c2a298af6ccf09fc9e58b9a71a1239b6.png";